import { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black text-white py-4 px-6 z-50 shadow-2xl">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold mb-1">¿Aceptas nuestras Cookies?</h3>
          <p className="text-sm text-gray-300">Utilizamos cookies para mejorar tu experiencia en la web.</p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="px-6 py-2 border-2 border-white text-white hover:bg-white hover:text-black rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            No
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2 border-2 border-white text-white hover:bg-white hover:text-black rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Sí
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
